// https://blog.cloudflare.com/browser-performance-api/

class WebAPM {
  getResult() {
    return {
      page: this.getPagePerf(),
      js: this.getJsPerf(),
      css: this.getCssPerf(),
      img: this.getImgPerf(),
      ajax: this.getAjaxPerf(),
    }
  }

  getPagePerf() {
    const perf = window.performance || window.webkitPerformance
    const timing = perf && perf.timing
    if (!timing) {
      return false
    }
    const {
      connectEnd,
      connectStart,
      domContentLoadedEventStart,
      domInteractive,
      domainLookupEnd,
      domainLookupStart,
      fetchStart,
      loadEventStart,
      navigationStart,
      requestStart,
      responseEnd,
      responseStart,
    } = timing

    return {
      plt: loadEventStart - navigationStart,
      dns: domainLookupEnd - domainLookupStart,
      tcp: connectEnd - connectStart,
      srt: responseStart - requestStart,
      pdt: responseEnd - responseStart,
      rrt: fetchStart - navigationStart,
      dit: domInteractive - navigationStart,
      clt: domContentLoadedEventStart - navigationStart,
    }
  }

  getResourceInfos(type) {
    return window.performance.getEntries().filter((item) => {
      if (item.entryType === 'resource' && item.initiatorType === type) {
        return item
      }
    })
  }

  getJsPerf() {
    return this.getResourceInfos('script')
  }

  getCssPerf() {
    return this.getResourceInfos('link')
  }

  getImgPerf() {
    return this.getResourceInfos('img')
  }

  getAjaxPerf() {
    return [
      ...this.getResourceInfos('fetch'),
      ...this.getResourceInfos('xmlhttprequest'),
    ]
  }

  getResourceCount(type) {
    return this.getResourceInfos(type).length || 0
  }

  getCount() {
    return {
      redirect: window.performance.navigation.redirectCount,
      js: this.getResourceCount('script'),
      css: this.getResourceCount('link'),
      ajax:
        this.getResourceCount('xmlhttprequest') +
        this.getResourceCount('fetch'),
      img: this.getResourceCount('img'),
    }
  }

  getResourceAllTime(type) {
    const allResource = window.performance
      .getEntries()
      .filter((ele) => ele.initiatorType === type)
    return (
      Math.max(...allResource.map((ele) => ele.responseEnd)) -
      Math.min(...allResource.map((ele) => ele.startTime))
    )
  }

  getJsAllTime() {
    return this.getResourceAllTime('script')
  }

  getCssAllTime() {
    // todo: 里面包含了css中的一部分图片资源，svg
    return this.getResourceAllTime('link')
  }

  getImgAllTime() {
    return this.getResourceAllTime('img')
  }

  getAjaxAllTime() {
    return (
      this.getResourceAllTime('fetch') +
      this.getResourceAllTime('xmlhttprequest')
    )
  }
}
const webAPM = new WebAPM()
export default webAPM
